import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ScriptService } from '../../services';
import { isNonEmptyString, isRealValue } from '@tr-common';
import { environment } from '../../../environments/environment';


  export const checkAndLoadImperiumScript = (
  qualityScoreClientID: string,
  scripts: ScriptService
): Observable<boolean> => {
  const qs = environment.qualityScore;

  // Validate inputs
  if (!isNonEmptyString(qualityScoreClientID) || !isRealValue(qs)) {
    return of(false);
  }

  const { scriptID, scriptName, scriptSrc } = qs;

  // Step 1: Force-remove existing script
  scripts.unloadScript(scriptName, '#qualityscore');

  // Step 2: Wrap unload result into observable before chaining
  return of(null).pipe(
    switchMap(() => {
      // Reset script state if cached
      if (scripts['scripts']?.[scriptName]) {
        scripts['scripts'][scriptName].loaded = false;
      }

      // Step 3: Re-register and load script
      scripts.register([{ id: scriptID, name: scriptName, src: scriptSrc }]);
      return scripts.loadScript(scriptName).pipe(map(() => true));
    })
  );
};
